import React from 'react';
import TokenNew from './TokenNew';
import TokenList from './TokenList';
import RouteMenu from 'mrf/view/MenuRoute';
import { Route } from 'react-router-dom';
import path from 'path';

export default function Token({ match }) {
    return (
        <RouteMenu match={match} indexComponent={TokenList}>
            <Route path={path.join(match.url, 'new')} component={TokenNew} />
        </RouteMenu>
    );
}